<template>
  <!-- 主内容 -->
  <div class="container">
    <van-nav-bar :title="$t('存款')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>

      <template #right>
        <img @click="service" style="width: 30px; " src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAI9SURBVHgB7ZjdccIwDIAVjvdmA9wNYINsUDYgnQA6AWwAG4ROQDtBugHtBKETwAaq1OgoOHb+bEIe+t3pWhJZkmXHsh2AJxAxpD+h/DwFQXCCe8IBkSxIUpIjmuF3a5IIuoKcjcVxUzKSGG6FZGyN7mQkqq7foI6SGNyRjC0qnyLf8ntEokQ/NOjz/HymefoGrnBw0mtTJngOhhXtY5K9JZszcEGGNdOM8gexgIZIZ44GW2NoCzVODFlrbdAyGlnVKNiMxYbeKnDEEuQammIwEoMnyFaERVQTA3r2EvAM2dxoPlZ1G/IQpFrjKXgG8wVfn0JhWYMI7RUiQ5evrehriXaSwnDTgxlWswFPoHld1ROiWHcg/9Rx/gDdoUh+5/2AJAZzObo3POUiDvAJ+suMA/Q2+W/AdAD9Jux7gPAfoCutA6QlYC6VR5XozETHac9Xl0Rrl16s+rH2jje6S1sVwupKcoaV9zV19QC52F/ukI8S9F57nqGWZawf4J6H+B1aQAcePiRNSA7yiKtRBNcHJT4UTUj3AO14HUJeh/nwoqAh4vgR84M5y0hefZF8SCfacoC8g+fhqkp7l7uZ4mEK843qtqSBAk+QrV2Jn6TSlwR7Kd52O3j9dWeYj553P22Dm2oZi6EvYHFZWkGXYH4STDC/YFLau7mWOW8fXN3gTLdeC/y7P7xkC12C5kO4jRU0ZAjuRBXv+aqNF+wXx4W7HVi8hdCH+e5Lh+mKjkmhL2DxxipFj5XHG3iDavADf6qIoLNv5gYAAAAASUVORK5CYII=">
      </template>
    </van-nav-bar>
    <!-- 积分兑换区 -->
    <div class="card" style="margin-top: 10px;background-color: #f2f5fe;">
      <div class="points-header">
        <div class="points-label">
          {{ $t("转换点数") }}
        </div>
      </div>
      <div class="points-input-wrapper">
        <input type="number" class="points-value" v-model="money"  :placeholder="$t('转换点数')" >
        <span class="points-unit">{{ $t("点") }}</span>
      </div>
      <div class="min-points-hint">{{ $t("最小值") }} {{ formatNumber(this.$store.getters.getBaseInfo.withraw_min) }} {{ $t("点") }}</div>
    </div>
    <!-- 快捷金额选择 -->
    <div class="card">
      <div class="quick-select-title">{{ $t("选择转换点的数量") }}</div>
      <div class="quick-select-subtitle">{{ $t("请选择要加载的点数") }}</div>
      <div class="amount-grid">
        <button class="amount-btn" v-for="(item,key) in data.recharge_amount" :key="key" @click="money = item">{{ formatNumber(item) }}</button>
      </div>
    </div>

    <!-- 银行账户信息 -->
    <div class="card">
      <div class="bank-info-title">{{ $t("收到的银行账户信息") }}</div>
      <div class="bank-info-desc">{{ $t("请提供正确的内容和积分，以便快速处理交易。") }}</div>

      <div class="bank-row">
        <div class="bank-row-left">
          <div class="bank-icon">
            <img src="/img/recharge/bank.jpg" class="icon">
          </div>
          <div>
            <div class="bank-text-label">{{ $t("银行") }}</div>
            <div class="bank-text-value">{{ data.bank_name }}</div>
          </div>
        </div>
        <div class="copy-btn" @click="copyText(data.bank_name)" ><img src="/img/recharge/copy.png" class="icon1"> {{ $t("复制") }}</div>
      </div>

      <div class="bank-row">
        <div class="bank-row-left">
          <div class="bank-icon">
            <img src="/img/recharge/card.jpg" class="icon">
          </div>
          <div>
            <div class="bank-text-label">{{ $t("账号") }}</div>
            <div class="bank-text-value">{{ data.card_no }}</div>
          </div>
        </div>
        <div class="copy-btn"  @click="copyText(data.card_no)"><img src="/img/recharge/copy.png" class="icon1"> {{ $t("复制") }}</div>
      </div>

      <div class="bank-row">
        <div class="bank-row-left">
          <div class="bank-icon">
            <img src="/img/recharge/user.jpg" class="icon">
          </div>
          <div>
            <div class="bank-text-label">{{ $t("账户持有人") }}</div>
            <div class="bank-text-value">{{ data.account_name }}</div>
          </div>
        </div>
        <div class="copy-btn" @click="copyText(data.account_name)" ><img src="/img/recharge/copy.png" class="icon1"> {{ $t("复制") }}</div>
      </div>

      <!-- 注意事项 -->
      <div class="notice-box" v-if="false">
        <div>
          <div class="notice-title"><img src="/img/recharge/halved.jpg" class="icon">{{ $t("注意") }}</div>
          <div class="notice-text">
            {{$t("请在转账前仔细检查您的帐户信息。")}}<br>
            {{ $t("我们只支持上述正确信息的交易。") }}
          </div>
        </div>
      </div>
      <div  v-if="data.tip_img">
        <img :src="data.tip_img" style="width: 100%">
      </div>

      <button type="button"  class="login-btn" @click="doRecharge">{{$t("确认")}}</button>

    </div>

  </div>


</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      data: [],
      money: ""
    };
  },
  methods: {

    doRecharge() {
      if(this.money < 0 || this.money == ''){

        this.$toast(this.$t("转换点数"));
        return false;
      }
      this.$http({
        method: 'get',
        url: 'money_recharge',
        data: {  money:this.money }
      }).then(res => {
        if (res.code === 200) {
          this.money = "";
          this.$toast.success(this.$t("提交成功"));
        } else if (res.code === 401) {
          this.$toast(this.$t(res.msg));
        }
      })
    },

    copyText(text) {
      const el = document.createElement('textarea');
      el.value = text;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.$toast.success(this.$t("复制成功"));
    },

    //客服
    service() {
      window.location.href = this.$store.getters.getBaseInfo.kefu;
    },

    back() {
      return window.history.back();
    },

    getRechargePei() {
      this.$http({
        method: 'get',
        url: 'recharge_info'
      }).then(res => {
        if (res.code === 200) {
          this.data = res.data;
        } else if (res.code === 401) {
          this.$toast(this.$t(res.msg));
        }
      })
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'})
    } else {
      this.getRechargePei();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.icon1{
  width: 16PX;
}
.icon{
  width: 18PX;
}
/* 顶部导航栏 */
.header {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56PX;
  background-color: #fff;
  position: relative;
  box-shadow: 0 1PX 3PX rgba(0,0,0,0.05);
}

.header h1 {
  font-size: 18PX;
  font-weight: 600;
}

.back-btn {
  position: absolute;
  left: 16PX;
  font-size: 20PX;
  color: #333;
  text-decoration: none;
}

/* 通用卡片样式 */
.card {
  background-color: #fff;
  border-radius: 12PX;
  padding: 16PX;
  box-shadow: 0 2PX 8PX rgba(0,0,0,0.02);
  margin: 0 16PX 12PX;
  border: 1px solid #f4f4f4;
}

/* 积分输入区 */
.points-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8PX;
}

.points-label {
  font-size: 15PX;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6PX;
}

.info-icon {
  font-size: 14PX;
  color: #888;
  border: 1PX solid #ccc;
  border-radius: 50%;
  width: 18PX;
  height: 18PX;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.points-input-wrapper {
  display: flex;
  align-items: baseline;
  border-bottom: 2PX dotted #4a90e2;
  padding-bottom: 10PX;
  margin-bottom: 8PX;
}

.points-value {
  font-size: 28PX;
  font-weight: bold;
  color: #1a73e8;
  border: none;
  background: transparent;
  outline: none;
  flex: 1;
  width: 100%;
}

.points-unit {
  font-size: 18PX;
  font-weight: 500;
  color: #333;
}

.min-points-hint {
  font-size: 13PX;
  color: #666;
}

/* 快捷金额选择区 */
.quick-select-title {
  font-size: 16PX;
  font-weight: 600;
  margin-bottom: 6PX;
}

.quick-select-subtitle {
  font-size: 13PX;
  color: #666;
  margin-bottom: 16PX;
}

.amount-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12PX;
}

.amount-btn {
  padding: 12PX 0;
  border: 1PX solid #e0e0e0;
  background-color: #fff;
  border-radius: 8PX;
  font-size: 15PX;
  font-weight: 500;
  color: #333;
  cursor: pointer;
  transition: all 0.2s;
}

.amount-btn:active, .amount-btn.active {
  border-color: #1a73e8;
  color: #1a73e8;
  background-color: #e8f0fe;
}

/* 银行信息区 */
.bank-info-title {
  font-size: 16PX;
  font-weight: 600;
  margin-bottom: 6PX;
}

.bank-info-desc {
  font-size: 13PX;
  color: #666;
  margin-bottom: 16PX;
  line-height: 1.5;
}

.bank-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14PX;
  background-color: #fafafa;
  border-radius: 10PX;
  margin-bottom: 10PX;
}

.bank-row:last-of-type {
  margin-bottom: 16PX;
}

.bank-row-left {
  display: flex;
  align-items: center;
  gap: 12PX;
  flex: 1;
}

.bank-icon {
  font-size: 24PX;
  color: #1a73e8;
  width: 36PX;
  height: 36PX;
  background-color: #e8f0fe;
  border-radius: 8PX;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bank-text-label {
  font-size: 13PX;
  color: #666;
  margin-bottom: 2PX;
}

.bank-text-value {
  font-size: 15PX;
  font-weight: 500;
  color: #333;
}

.copy-btn {
  font-size: 13PX;
  color: #1a73e8;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4PX;
}

/* 注意事项 */
.notice-box {
  display: flex;
  align-items: flex-start;
  gap: 10PX;
  background-color: #e8f0fe;
  padding: 12PX;
  border-radius: 10PX;
}

.notice-icon {
  font-size: 18PX;
  color: #1a73e8;
  margin-top: 2PX;
}

.notice-title {
  font-size: 13PX;
  font-weight: 600;
  margin-bottom: 4PX;
  display: flex;
  align-items: center;
  color: #1a73e8;
}

.notice-text {
  font-size: 13PX;
  color: #555;
  line-height: 1.4;
}

/* 底部继续按钮 */
.bottom-action {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 16PX;
  background-color: #fff;
  box-shadow: 0 -2PX 10PX rgba(0,0,0,0.05);
  z-index: 100;
}

.continue-btn {
  width: 100%;
  padding: 14PX;
  background-color: #b00000; /* 品牌红色 */
  color: #fff;
  border: none;
  border-radius: 8PX;
  font-size: 16PX;
  font-weight: 600;
  cursor: pointer;
}

/* 右下角悬浮按钮 */
.fab {
  position: fixed;
  bottom: 70PX;
  right: 16PX;
  width: 40PX;
  height: 40PX;
  background-color: #b00000;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18PX;
  box-shadow: 0 4PX 10PX rgba(0,0,0,0.2);
  z-index: 101;
}

/* 登录按钮 */
.login-btn {
  width: 100%;
  background-color: #d8000f;
  color: white;
  border: none;
  padding: 14PX;
  border-radius: 8PX;
  font-size: 16PX;
  font-weight: bold;
  cursor: pointer;
  margin-bottom: 25PX;
  transition: background-color 0.2s;
  margin-top: 20PX;
}

.login-btn:hover {
  background-color: #c0000d;
}
</style>
